import React from 'react';
import { Box, BoxProps } from '@mezzoforte/forge';

export const FocusableBox = <T extends object>(Component: React.FC) => {
  function StyledComponent(props: BoxProps & T) {
    return (
      <Box
        as={Component}
        sx={{
          _hover: {
            outline: '1px solid',
            outlineColor: 'inputBorder',
            _safari: {
              outline: 'none',
            },
          },
          _active: {
            outline: '1px solid',
            outlineColor: 'inputBorder',
            _safari: {
              outline: 'none',
            },
          },
          _focus: {
            boxShadow: '0 4px 4px rgba(0, 0, 0, 0.25), 0 0 0 3px rgba(192, 86, 33, 0.6)',
          },
        }}
        {...props}
      />
    );
  }

  return StyledComponent as React.FC<React.PropsWithChildren<T>>;
};
